import  ApiService  from '../../services/api.service'
import HashMake from '../../services/hash.service'

const state = {
    downloads: [],
    loading: false
}

const getters = {
    fetchDownloads : (state) => {
        return state.downloads;
    },
    loading: state => state.loading,
}

const actions = {
    fetchDownloadDetails({commit}, lang) {
        commit('setLoading', true)
        let params = { lang: HashMake.encrypt(lang) }

        ApiService.post('downloads', params).then((result) => {
            commit('setDownloads',result.data);
            }).catch((e) => {
                
            }).finally(() => {
                commit('setLoading', false)
            })
    },

    logDownloadsFileDownload({commit}, newsParams) {
        let params = { downloadTitle: HashMake.encrypt(newsParams.title), downloadFileName: HashMake.encrypt(newsParams.fileName) }

        ApiService.post('log-download', params).then((response) => {
        })
    }
}

const mutations = {
    setDownloads(state, data){
        state.downloads = data
    },
    setLoading(state, loading) {
        state.loading = loading
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}